import { FC } from "react";
import {
  CoverageAvailableProps,
} from "../actionDashboard/types";
import { APIEndpoints } from "src/types/apiTypes";

export type CopayCompletedClaimsType = {
  case_id: number;
  claim_status: string;
  notes: string;
  paid_claim_amount: string;
  paid_claim_date: string;
  patient_name: string;
  product:string;
  remaining_copay_available: number;
  submitting_practice: string;
};
export type CompletedClaimsResponseType = {
  max_page: number;
  message: string;
  records: CopayCompletedClaimsType[];
  report_name:string;
  response:string
};
export type CopayCasesTabConfig = {
  key: string;
  label: string;
  Component: FC<any>;
  dataSelector: (data: any) => any;
  pageKey: keyof ClaimQueryParamsState;
  changeAction: string;
};
export type CopayAllClaimsTypeProps = {
  tableData: AllClaimsTypeProps;
  refreshListing: () => void;
  currentPage: number;
  onPageChange: () => void;
  changeAction: string;
  initialState: ClaimQueryParamsState;
  activeTab:CopayCasesTabConfig;
  downloadExcelFile: () => void;
  handlePageChange : () => void;
  updateQueryParamsAndCallAPI : () => void;
  FilterComponent: FC<any>;
};
export type CopayCompletedClaimsTypeProps = {
  tableData: CopayCompletedClaimsType[];
  refreshListing: () => void;
  currentPage: number;
  onPageChange: () => void;
  changeAction: string;
  initialState: ClaimQueryParamsState;
  activeTab:CopayCasesTabConfig;
  downloadExcelFile: () => void;
  handlePageChange : () => void;
  updateQueryParamsAndCallAPI : () => void;
  FilterComponent: FC<any>;
};
export type CopayClaimsProps = {
  initialState: ClaimQueryParamsState;
  tabs: CopayCasesTabConfig[];
};

export type AllClaimsTypeProps = {
  case_id: number
  copay: string
  days_left: number;
  patient_name: string;
  product: string
  status: string
  submitted_date: string
  submitting_practice: string
  next_step:boolean;
};
export type ClaimQueryParamsState = {
  sort_by: string;
  direction: "asc" | "desc";
  search_query: string;
  page: number;
  pagination: boolean;
  case_id: string;
  start_date: string;
  end_date: string;
  patient_name: string;
  claim_status: string;
  file_required: boolean;
};
export type AllClaimsResponseType = {
  max_page: number;
  message: string;
  records: AllClaimsTypeProps[];
  report_name:string;
  response:string
};
export enum ClaimQueryStateActions {
  CHANGE_CLAIM_STATUS = "changeClaimStatus",
  CHANGE_SORT_PARAMS = "changeSortParams",
  CHANGE_SEARCH_QUERY = "changeSearchQuery",
  CHANGE_START_DATE = "changeStartDate",
  CHANGE_END_DATE = "changeEndDate",
  CLEAR_STATE = "clearState",
  CHANGE_PAGE = "changePage",
  CHANGE_PAGINATION_BIT = "changePaginationBit",
  CHANGE_CASE_ID = "changeCaseID",
  CHANGE_PATIENT_NAME = "changePatientName",
 
}
export type ClaimQueryStateActionType =
  | {
      type: ClaimQueryStateActions.CHANGE_CLAIM_STATUS;
      payload:  string;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_CASE_ID;
      payload:  string;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_PATIENT_NAME;
      payload:  string;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_SORT_PARAMS;
      payload: {
        sort_by: string;
        direction: "asc" | "desc";
      };
    }
  | {
      type: ClaimQueryStateActions.CHANGE_SEARCH_QUERY;
      payload: string;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_START_DATE;
      payload: string;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_END_DATE;
      payload: string;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_PAGE;
      payload: number;
    }
  | {
      type: ClaimQueryStateActions.CLEAR_STATE;
      payload: boolean;
    }
  | {
      type: ClaimQueryStateActions.CHANGE_PAGINATION_BIT;
      payload: boolean;
    };
